/***
*
*   SIGN IN
*   Sign in 
*
**********/

import { useContext, useEffect, useCallback, useRef, useState } from 'react';
import Axios from 'axios';
import { Animate, AuthContext, Form, Card, Row, Button } from 'components/lib';
import { entraAuth } from 'app/config';
import { reauthenticate, sessionLost } from 'app/auth';

export const NO_ACCESS = 'Your Microsoft account has no Mission Control access. Ask to be added to SG-SLT or SG-SALES.';
export const SIGNIN_FAILED = 'Mission Control could not confirm your Microsoft sign-in.';

export function Signin(){

  // context
  const context = useContext(AuthContext);
  
  if (entraAuth())
    return <MicrosoftSignin />;

  return(
    <Animate type='pop'>
      <Row title='Sign in to Mission Control'>
        <Card restrictWidth center>
          <Form
            inputs={{
              email: {
                label: 'Email',
                type: 'email',
                required: true,
              },
              password: {
                label: 'Password',
                type: 'password',
                required: true,
              }
            }}
            method='POST'
            buttonText='Sign In'
            url={ `${context.remote_server}/api/auth`}
            callback={ context.signin }
          />

        </Card>
      </Row>
    </Animate>
  );
}

// CORE-4859: in a cell the ALB has signed the user in with Microsoft before
// this page loads, so ask Mission Control who they are. Axios directly, not
// useAPI: its 401 handling would bring the user straight back here.
function MicrosoftSignin(){

  const context = useRef(useContext(AuthContext));
  const [status, setStatus] = useState('loading');

  const check = useCallback(async () => {

    setStatus('loading');

    try {

      // the profile is the whole body, as the webapp's /api/auth sends it
      const res = await Axios({ url: '/api/me', method: 'get' });

      if (res.data?.permission === 'master')
        return context.current.signin(res);

      setStatus('no_access');

    }
    catch (err){

      const code = err.response?.status;

      if (code === 403)
        return setStatus('no_access');

      if ((code === 401 || sessionLost(err)) && reauthenticate())
        return;

      setStatus('error');

    }
  }, []);

  useEffect(() => {

    check();

  }, [check]);

  return(
    <Animate type='pop'>
      <Row title='Sign in to Mission Control'>
        <Card restrictWidth center loading={ status === 'loading' }>

          { status === 'no_access' &&
            <>
              <p style={{ marginBottom: 16 }}>{ NO_ACCESS }</p>
              <Button fullWidth text='Sign out' action={ () => context.current.signout() } />
            </> }

          { status === 'error' &&
            <>
              <p style={{ marginBottom: 16 }}>{ SIGNIN_FAILED }</p>
              <Button fullWidth text='Retry' action={ check } />
            </> }

        </Card>
      </Row>
    </Animate>
  );
}
